import React, { useMemo, useState, useEffect, Fragment } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

// Componentes existentes en tu proyecto
import EncabezadoEvaluador from "./EncabezadoEvaluador";

import EquipoGerencia from "../Autoevaluacion/Equipos/SeccionF/EquipoGerencia";
import EquipoTalentoHumano from "../Autoevaluacion/Equipos/SeccionF/EquipoTalentoHumano";
import EquipoAmbienteFisico from "../Autoevaluacion/Equipos/SeccionF/EquipoAbienteFisico";
import EquipoTecnologia from "../Autoevaluacion/Equipos/SeccionF/EquipoTecnologia";
import EquipoGerenciaInformacion from "../Autoevaluacion/Equipos/SeccionF/EquipoGerenciaInformacion";
import Cuadro1EncuestaUsuario from "../Encuestas/Cuadro1EncuestaUsuario";
import Cuadro1EncuestaTranajadores from "../Encuestas/Cuadro1EncuestaTrabjadores";
import CuadroTrazador from "../Encuestas/CuadroTrazador";
import MorbilidadInforme from "../Evaluador/MorbilidadMortalidadInforme/MorbilidadInforme";
import MortalidadInforme from "../Evaluador/MorbilidadMortalidadInforme/MortalidadInforme";
import ObtenerAdjuntos from "./ObtenerAdjuntos";
import ResumenOmEvaluador from "../Evaluador/MorbilidadMortalidadInforme/ResumenOmInformeE";
import Tabla11Obtener from "./Tabla11Obtener";
import TrabajdoresInforme from "./TrabajadoresInforme";
import IndicadorGrupoA1 from "./IndicadorGrupoA1";
import {
  gerentePorInstitucion,
  representanteLegalPorInstitucion,
} from "../../Services/Rest";
import InfoTrabajadores from "../Funciones/InfoTrabajadores";
import EquipoDireccionamiento from "../Autoevaluacion/Equipos/SeccionF/EquipoDireccionamiento";

/**
 * ===========================
 *   OPTIMIZACIONES CLAVE
 * ===========================
 * - Unifica llamadas axios en menos efectos con Promise.all
 * - Crea una instancia axios con baseURL y (opcional) auth
 * - Corrige dependencias de useEffect (idInstitucion / idSolicitud)
 * - useMemo para todos los filtros derivados: evita re-cómputos
 * - Helpers reutilizables para reducir JSX repetitivo (Section, Lines)
 * - Manejo seguro de errores y estados de carga
 * - Quita console.log de producción
 */

// ⚠️ Reemplaza con variables de entorno en tu app real
const BASIC_AUTH = {
  username: process.env.REACT_APP_BASIC_USER || "BasicAuth@icontec.org",
  password: process.env.REACT_APP_BASIC_PASS || "yQLzqmR7eZSuAmQZUqhY",
};

const api = axios.create({
  baseURL: "https://suadesarrollo.azurewebsites.net/",
});

const get = (url, withAuth = false) =>
  api.get(url, withAuth ? { auth: BASIC_AUTH } : undefined).then((r) => r.data);

const Lines = ({ text }) => {
  if (!text) return null;
  return (
    <>
      {String(text)
        .split("\n")
        .map((line, i) => (
          <Fragment key={i}>
            {line}
            <br />
          </Fragment>
        ))}
    </>
  );
};

const Section = ({ title, children }) => (
  <div className="text-justify">
    {title ? (
      <div className="card-header py-3">
        <h6 className="m-0 font-weight-bold text-primary">{title}</h6>
      </div>
    ) : null}
    <div className="table-responsive">
      <center>
        <table border={0}>
          <thead>
            <tr>
              <div className="text-center">
                <br />
              </div>
            </tr>
          </thead>
          <tbody>{children}</tbody>
        </table>
      </center>
    </div>
  </div>
);

const RowFromComentarios = ({ items }) => (
  <tr>
    <td className="text-justify">
      <h6>
        {items?.map((it, idx) => (
          <tr key={idx}>
            <td className="text-justify">
              <Lines text={it.comentarios} />
            </td>
          </tr>
        ))}
      </h6>
    </td>
  </tr>
);

const InformeEvaluador = () => {
  const { idInstitucion, idSolicitud } = useParams();

  // ===================
  // Estados remotos
  // ===================
  const [perfilAuto, setPerfilAuto] = useState([]);
  const [tipoSolicitud, setTipoSolicitud] = useState([]);
  const [conteoEval, setConteoEval] = useState([]);
  const [institucion, setInstitucion] = useState([]);
  const [repLegal, setRepLegal] = useState([]);
  const [gerente, setGerente] = useState([]);
  const [fechas, setFechas] = useState([]); // solo primer registro
  const [liderSolicitud, setLiderSolicitud] = useState([]);
  const [equipoUsuario, setEquipoUsuario] = useState([]);
  const [resultados, setResultados] = useState([]);
  const [tareas, setTareas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // ===================
  // Cargas en paralelo
  // ===================
  useEffect(() => {
    let mounted = true;
    setLoading(true);
    setError(null);

    Promise.all([
      get(`/api/ObtenerPerfilAutoevaluacion/${idInstitucion}`),
      get(`/api/ObtenerSolicitudesPorId?Id=${idSolicitud}`, true),
      get(`/api/ObtenerConteoEvaluaciones/3/${idSolicitud}`, true),
      get(`/Api/ObtenerInstitucionesPorId?Id=${idInstitucion}`),
      get(representanteLegalPorInstitucion + idInstitucion),
      get(gerentePorInstitucion + idInstitucion),
      get(`/api/ObtenerFecha/${idSolicitud}`, true),
      get(
        `/api/ObtenerLiderSolicitudesPorSolicitudId?SolicitudId=${idSolicitud}`,
        true,
      ),
      get(`/api/QEquipoUsuario?SolicitudId=${idSolicitud}`, true),
      get(`/api/ObtenerResultados/3/${idSolicitud}`, true),
      get(`/api/obtenerTareasPorSolicitud/${idSolicitud}`, true),
    ])
      .then(
        ([
          perfil,
          tipo,
          conteo,
          inst,
          rep,
          ger,
          fechasAll,
          lider,
          equipo,
          resultadosAll,
          tareasAll,
        ]) => {
          if (!mounted) return;
          setPerfilAuto(perfil || []);
          setTipoSolicitud(tipo || []);
          setConteoEval(conteo || []);
          setInstitucion(inst || []);
          setRepLegal(rep || []);
          setGerente(ger || []);
          setFechas(fechasAll?.length ? [fechasAll[0]] : []);
          setLiderSolicitud(lider || []);
          setEquipoUsuario(equipo || []);
          setResultados(resultadosAll || []);
          setTareas(tareasAll || []);
        },
      )
      .catch((e) => {
        if (!mounted) return;
        setError(e?.message || "Error cargando datos");
      })
      .finally(() => mounted && setLoading(false));

    return () => {
      mounted = false;
    };
  }, [idInstitucion, idSolicitud]);

  // ===================
  // Derivados / filtros
  // ===================
  const estructuraOrg = useMemo(
    () =>
      perfilAuto.filter((e) => e.titulo === "2. Estructura organizacional "),
    [perfilAuto],
  );

  const lastRepLegal = useMemo(
    () => (repLegal?.length ? repLegal[repLegal.length - 1] : null),
    [repLegal],
  );
  const lastGerente = useMemo(
    () => (gerente?.length ? gerente[gerente.length - 1] : null),
    [gerente],
  );

  const equipoLider = useMemo(
    () => equipoUsuario.filter((e) => e.nombreRol === "LIDER"),
    [equipoUsuario],
  );
  const equipoEvaluador = useMemo(
    () => equipoUsuario.filter((e) => e.nombreRol === "EVALUADOR"),
    [equipoUsuario],
  );

  // Resultados
  const resultadosAbierta = useMemo(
    () => resultados.filter((e) => e.tipoRespuesta === "Abierta"),
    [resultados],
  );
  const resultadosSeleccion = useMemo(
    () => resultados.filter((e) => e.tipoRespuesta === "Seleccion"),
    [resultados],
  );
  const resultadosCalificacion = useMemo(
    () => resultados.filter((e) => e.tipoRespuesta === "Calificacion"),
    [resultados],
  );

  // Tareas: crea un helper para evitar repetir filter constantemente
  const tBy = useMemo(() => {
    const map = new Map();
    for (const t of tareas) {
      if (!map.has(t.nombretarea)) map.set(t.nombretarea, []);
      map.get(t.nombretarea).push(t);
    }
    return (name) => map.get(name) || [];
  }, [tareas]);

  // ===================
  // UI: Estados base
  // ===================
  if (loading) {
    return (
      <div className="container py-5 text-center">
        <div className="spinner-border" role="status" />
        <p className="mt-3">Cargando informe…</p>
      </div>
    );
  }
  if (error) {
    return (
      <div className="container py-5">
        <div className="alert alert-danger">{error}</div>
      </div>
    );
  }

  // ===================
  // RENDER
  // ===================
  return (
    <div className="container">
      <EncabezadoEvaluador />

      {/* ================= GENERALIDADES ================= */}
      <div className="container ">
        <div className="text-center">
          <div className="container-fluid">
            <div className="card shadow mb-4">
              <div className="card-header py-3">
                <h5 className="m-0 font-weight-bold text-primary">
                  GENERALIDADES
                </h5>
                <div className="card-body">
                  <div className="table-responsive">
                    <div className="text-justify">
                      <thead>
                        <tr>
                          <th>
                            <h4 className="m-0 font-weight-bold">
                              INSTITUCIÓN :{" "}
                              {institucion
                                .map((i) => i.razon_Social)
                                .join(", ")}
                            </h4>
                          </th>
                          <br />
                        </tr>
                        <tr>
                          <th>
                            <h4 className="m-0 font-weight-bold ">
                              CIUDAD:{" "}
                              {institucion.map((i) => i.ciudad).join(", ")}
                            </h4>
                          </th>
                          <br />
                        </tr>
                        <tr>
                          <th>
                            <h6 className="m-0 font-weight-bold">ALCANCE</h6>
                          </th>
                          <br />
                        </tr>
                        {tBy("Alcance").map((item, idx) => (
                          <tr className="text-justify" key={`alc-${idx}`}>
                            <td>
                              <Lines text={item.comentarios} />
                            </td>
                          </tr>
                        ))}
                        <tr>
                          <th>
                            <h6 className="m-0 font-weight-bold">
                              TIPO DE EVALUACIÓN
                            </h6>
                          </th>
                          <br />
                        </tr>
                        {tipoSolicitud.map((item, idx) => (
                          <tr key={`tipo-${idx}`}>
                            <td>{item.tipoSolicitud}</td>
                          </tr>
                        ))}
                        <tr>
                          <th>
                            <h6 className="m-0 font-weight-bold">
                              FECHA DE LA EVALUACIÓN:
                            </h6>
                          </th>
                          <br />
                        </tr>
                        {fechas.map((f, idx) => (
                          <tr key={`fec-${idx}`}>
                            <td>
                              {(f?.fechaInicio || "na") +
                                " - " +
                                (f?.fechaFin || "na")}
                            </td>
                          </tr>
                        ))}
                        <tr>
                          <th>
                            <h6 className="m-0 font-weight-bold">
                              REPRESENTANTE LEGAL DE LA INSTITUCIÓN
                            </h6>
                          </th>
                          <br />
                        </tr>
                        <tr>
                          <td>
                            {lastRepLegal
                              ? lastRepLegal.nombre
                              : "No hay datos disponibles"}
                          </td>
                        </tr>
                        <tr>
                          <th>
                            <h6 className="m-0 font-weight-bold">
                              DIRECTOR O GERENTE:
                            </h6>
                          </th>
                          <br />
                        </tr>
                        <tr>
                          <td>
                            {lastGerente
                              ? lastGerente.nombre
                              : "No hay datos disponibles"}
                          </td>
                        </tr>
                        <tr>
                          <th>
                            <h6 className="m-0 font-weight-bold">
                              LÍDER DE ACREDITACIÓN EN LA INSTITUCIÓN:
                            </h6>
                          </th>
                          <br />
                        </tr>
                        {liderSolicitud.map((l, idx) => (
                          <tr key={`lider-${idx}`}>
                            <td>{l.nombre}</td>
                          </tr>
                        ))}
                        <tr>
                          <th>
                            <h6 className="m-0 font-weight-bold">
                              EVALUADOR LIDER:
                            </h6>
                          </th>
                          <br />
                        </tr>
                        {equipoLider.map((e, idx) => (
                          <tr key={`elid-${idx}`}>
                            <td>{e.nombre}</td>
                          </tr>
                        ))}
                      </thead>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div className="text-center">
          <div class="card-header py-3">
            <h5 class="m-0 font-weight-bold text-primary">
              2. OBJETIVOS DE LA EVALUACIÓN
            </h5>
          </div>
        </div>
        <div className="text-justify">
          <div class="table-responsive">
            <center>
              <table border={0}>
                <thead>
                  <tr>
                    <div className="text-center">
                      <br></br>
                    </div>
                  </tr>
                </thead>

                <tbody>
                  <tr>
                    <td>
                      <h6>
                        • Determinar el avance sistémico en la implementación de
                        los estándares de acreditación en salud, establecidos en
                        la Resolución 5095 de 19 de noviembre de 2018{" "}
                      </h6>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <h6>
                        • Verificar los resultados de las acciones implementadas
                        para las oportunidades de mejoramiento de la evaluación
                        anterior.{" "}
                      </h6>{" "}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <h6>
                        • Identificar fortalezas y oportunidades de mejoramiento
                        de la calidad.
                      </h6>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <h6>
                        • Profundizar en algunos temas de evaluación que
                        agreguen mayor valor a la institución y contribuyan al
                        mejoramiento continuo de la evaluación.{" "}
                      </h6>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <h6>
                        • Avanzar en la evaluación de resultados con base en
                        indicadores.{" "}
                      </h6>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <h6>
                        {" "}
                        • Determinar los avances para el manejo de la pandemia
                      </h6>
                    </td>
                  </tr>
                </tbody>
              </table>
            </center>
          </div>
        </div>
      </div>
      <Section title="REUNION DE APERTURA">
        <RowFromComentarios items={tBy("Reunion de apertura")} />
      </Section>
      {/* ================= SECCIONES (extracto) ================= */}
      <Section title="4.1 ANÁLISIS DE LOS PRINCIPALES CAMBIOS, AVANCES Y FORTALEZAS INSTITUCIONALES">
        <RowFromComentarios
          items={tBy(
            "4.1 ANALISIS DE LOS PRINCIPALES CAMBIOS, AVANCES Y FORTALEZAS INSTITUCIONALES",
          )}
        />
      </Section>

      <Section title="4.2. NOVEDADES EN SERVICIOS OFERTADOS Y CAMAS DISPONIBLES">
        <RowFromComentarios
          items={tBy(
            "4.2.\tNOVEDADES EN SERVICIOS OFERTADOS Y CAMAS DISPONIBLES ",
          )}
        />
      </Section>

      <Section title="4.3. PLATAFORMA ESTRATÉGICA, CAMBIOS">
        <RowFromComentarios
          items={tBy("4.3.\tPLATAFORMA ESTRATEGICA, CAMBIOS.  ")}
        />
        <RowFromComentarios items={tBy("4.3.1 Mision ")} />
        <RowFromComentarios items={tBy("4.3.2 Vision")} />
        <RowFromComentarios items={tBy("4.3.3 Valores")} />
        <RowFromComentarios items={tBy("4.3.4 Principios ")} />
        <RowFromComentarios items={tBy("4.3.5 Politica de Seguridad  ")} />
        <RowFromComentarios items={tBy("4.3.6 Politica de Humanizacion    ")} />
        <RowFromComentarios
          items={tBy("4.3.7 Politica de Seguridad y Salud en el Trabajo")}
        />
        <RowFromComentarios
          items={tBy("4.3.8 Politica de Gestion de la Tecnologia")}
        />
        <RowFromComentarios items={tBy("4.3.9 ESTRUCTURA ORGANIZACIONAL")} />
        {/* Adjuntos por subtítulos: ejemplo */}
        <tr>
          <td>
            <table className="table">
              <tbody>
                {tBy("4.3.9 ESTRUCTURA ORGANIZACIONAL").map((it, idx) => (
                  <tr key={`estr-${idx}`}>
                    <td>
                      <Lines text={it.descripcion} />
                    </td>
                    <td>
                      <ObtenerAdjuntos
                        idInstitucionId={idInstitucion}
                        Id={it.subtitulosId}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </td>
        </tr>
      </Section>

      <Section title="4.4. POBLACIÓN A LA QUE PRESTA LOS SERVICIOS">
        <RowFromComentarios
          items={tBy("4.4.POBLACION A LA QUE PRESTA LOS SERVICIOS")}
        />
        <IndicadorGrupoA1 id={idInstitucion} />
      </Section>

      <Section title="4.5. PERFIL DE MORBILIDAD Y MORTALIDAD">
        <RowFromComentarios
          items={tBy("4.5.PERFIL DE MORBILIDAD Y MORTALIDAD")}
        />
        <div className="text-justify">
          <div className="card-header py-3">
            <h6 className="m-0 font-weight-bold text-primary">MORBILIDAD</h6>
          </div>
        </div>
        <MorbilidadInforme id={idInstitucion} />
        <div className="text-justify">
          <div className="card-header py-3">
            <h6 className="m-0 font-weight-bold text-primary">MORTALIDAD</h6>
          </div>
        </div>
        <MortalidadInforme id={idInstitucion} />
      </Section>

      <Section title="4.6. AVANCES EN COMPARACIÓN Y REFERENCIACIÓN">
        <RowFromComentarios
          items={tBy("4.6.\tAVANCES EN COMPARACION Y REFERENCIACION")}
        />
      </Section>

      {/* ENTREVISTAS */}
      <Section title="4.7. ENTREVISTAS">
        <RowFromComentarios items={tBy("4.7.ENTREVISTAS")} />
      </Section>
      <Section title="4.7.1. Entrevistas con el Líder y varios miembros de cada equipo de autoevaluación">
        <RowFromComentarios
          items={tBy(
            "4.7.1.Entrevistas con el Lider y varios miembros de cada equipo de autoevaluacion",
          )}
        />
      </Section>
      <Section title="4.7.2. Entrevista con Asociación de Usuarios">
        <RowFromComentarios
          items={tBy("4.7.2.\tEntrevista con Asociacion de Usuarios")}
        />
      </Section>
      <Section title="4.7.3. Sistema de información y atención al usuario">
        <RowFromComentarios
          items={tBy("4.7.3.\tSistema de informacion y atencion al usuario")}
        />
      </Section>
      <Section title="4.7.4. Entrevista a Junta Directiva">
        <RowFromComentarios
          items={tBy("4.7.4.\tEntrevista a Junta Directiva")}
        />
      </Section>

      {/* SEGURIDAD DEL PACIENTE, RIESGO, HUMANIZACIÓN, ETC. */}
      <Section title="5.1. SEGURIDAD DEL PACIENTE">
        <RowFromComentarios items={tBy("5.1.\tSEGURIDAD DEL PACIENTE")} />
        <RowFromComentarios
          items={tBy("5.1.1.\tPrograma de seguridad del paciente")}
        />
        <RowFromComentarios
          items={tBy(
            "5.1.2.\tGuia de Buenas Practicas para la Seguridad del Paciente",
          )}
        />
        <RowFromComentarios
          items={tBy("5.1.3.\tControl y Prevencion de Infecciones")}
        />
        <RowFromComentarios items={tBy("5.1.4.\tHemovigilancia")} />
        <RowFromComentarios
          items={tBy("5.1.5.\tGestion de Medicamentos y Farmacovigilancia")}
        />
        <RowFromComentarios items={tBy("5.1.6.\tReactivovigilancia")} />
        <RowFromComentarios items={tBy("5.1.7.\tBiovigilancia")} />
        <RowFromComentarios
          items={tBy(
            "5.1.8.\tGestion de Complicaciones, Incidentes y Eventos Adversos",
          )}
        />
        <RowFromComentarios items={tBy("5.1.9.\tTecnovigilancia  ")} />
      </Section>

      <Section title="5.2. GESTIÓN DEL RIESGO">
        <RowFromComentarios items={tBy("5.2.\tGESTION DEL RIESGO")} />
      </Section>

      <Section title="5.3. HUMANIZACIÓN DE LA ATENCIÓN">
        <RowFromComentarios items={tBy("5.3.\tHUMANIZACION DE LA ATENCION")} />
      </Section>

      <Section title="5.4. GESTIÓN DE TECNOLOGÍA">
        <RowFromComentarios items={tBy("5.4.\tGESTION DE TECNOLOGIA")} />
      </Section>

      <Section title="5.5.	TRANSFORMACION CULTURAL">
        <RowFromComentarios items={tBy("5.5.	TRANSFORMACION CULTURAL")} />
      </Section>

      <Section title="5.6. RESPONSABILIDAD SOCIAL">
        <RowFromComentarios items={tBy("5.6.\tRESPONSABILIDAD SOCIAL")} />
      </Section>

      {/* 6. FORTALEZAS, AVANCES Y DESARROLLOS DE LOS ESTÁNDARES ASISTENCIALES */}
      <div className="text-center">
        <div className="card-header py-3">
          <h5 className="m-0 font-weight-bold text-primary">
            6. FORTALEZAS, AVANCES Y DESARROLLOS DE LOS ESTÁNDARES ASISTENCIALES
          </h5>
        </div>
      </div>

      <Section title="6.1. RESULTADOS DEL PACIENTE TRAZADOR">
        <thead>
          <tr>
            <div className="text-justify">
              <h6 className="m-0 font-weight-bold text-primary">
                conclusiones
              </h6>
            </div>
          </tr>
        </thead>
        <RowFromComentarios
          items={tBy("6.1.\tRESULTADOS DEL PACIENTE TRAZADOR")}
        />
        <div className="table-responsive">
          <CuadroTrazador idSolicitud={idSolicitud} />
        </div>
      </Section>

      <Section title="6.2. RESULTADOS DE ENTREVISTA A USUARIOS">
        <RowFromComentarios
          items={tBy("6.2.\tRESULTADOS DE ENTREVISTA A USUARIOS")}
        />
        <div className="table-responsive">
          <Cuadro1EncuestaUsuario idSolicitud={idSolicitud} />
        </div>
      </Section>

      <Section title="6.3. RESULTADOS DE ENTREVISTA A TRABAJADORES (ENFOQUE EJES)">
        <RowFromComentarios
          items={tBy(
            "6.3.\tRESULTADOS DE ENTREVISTA A TRABAJADORES  (ENFOQUE EJES) ",
          )}
        />
        <div className="table-responsive">
          <Cuadro1EncuestaTranajadores idSolicitud={idSolicitud} />
        </div>
      </Section>

      <Section title="6.4. AVANCES EN GESTIÓN CLÍNICA">
        <RowFromComentarios items={tBy("6.4.\tAVANCES EN GESTION CLINICA")} />
      </Section>

      <Section title="6.5. RUTA DE ATENCIÓN">
        <RowFromComentarios items={tBy("6.5.\tRUTA DE ATENCION")} />
      </Section>

      <Section title="6.5.1 Servicios Hospitalarios">
        <RowFromComentarios items={tBy("6.5.1 Servicios Hospitalarios")} />
      </Section>

      <Section title="6.5.2 Servicios Ambulatorios">
        <RowFromComentarios items={tBy("6.5.2 Servicios Ambulatorios")} />
      </Section>

      <Section title="6.5.3 Laboratorio Clinico, Gestion Pretransfusional y Laboratorio de Patologia">
        <RowFromComentarios
          items={tBy(
            "6.5.3 Laboratorio Clinico, Gestion Pretransfusional y Laboratorio de Patologia",
          )}
        />
      </Section>
      <Section title="6.5.4 Imagenes Diagnosticas y Terapeuticas">
        <RowFromComentarios
          items={tBy("6.5.4 Imagenes Diagnosticas y Terapeuticas")}
        />
      </Section>
      <Section title="6.5.5 Rehabilitacion">
        <RowFromComentarios items={tBy("6.5.5 Rehabilitacion")} />
      </Section>
      <Section title="6.5.6 Odontologia">
        <RowFromComentarios items={tBy("6.5.6 Odontologia")} />
      </Section>

      <Section title="6.6 ACCIONES IMPLEMENTAS POST PANDEMIA">
        <RowFromComentarios
          items={tBy("6.6.\tACCIONES IMPLEMENTAS POST PANDEMIA")}
        />
      </Section>
      <Section title="6.7.	HALLAZGOS DE SEDES INTEGRADAS EN RED.">
        <RowFromComentarios
          items={tBy("6.7.\tHALLAZGOS DE SEDES INTEGRADAS EN RED.")}
        />
      </Section>

      <Section title="6.8. COMITÉS ASISTENCIALES">
        <RowFromComentarios items={tBy("6.8.\tCOMITES ASISTENCIALES.")} />
      </Section>

      <Section title="6.9. GESTIÓN DE LOS SERVICIOS ASISTENCIALES TERCERIZADOS">
        <RowFromComentarios
          items={tBy(
            "6.9.\tGESTION DE LOS SERVICIOS ASISTENCIALES TERCERIZADOS",
          )}
        />
      </Section>

      <Section title="6.10. RESULTADOS Y ANÁLISIS DE INDICADORES ASISTENCIALES">
        <RowFromComentarios
          items={tBy(
            "6.10.\tRESULTADOS Y ANALISIS DE INDICADORES ASISTENCIALES",
          )}
        />
      </Section>

      <Section title="6.11. RESULTADOS OPORTUNIDADES DE MEJORAMIENTO (JUNTA) ANTERIOR">
        <RowFromComentarios
          items={tBy(
            "6.11.\tRESULTADOS DE LA IMPLEMENTACION DE LAS OPORTUNIDADES DE MEJORAMIENTO ASISTENCIALES (JUNTA) DE LA EVALUACION ANTERIOR.",
          )}
        />
      </Section>

      <Section title="6.12. CONCLUSIONES (FORTALEZAS Y OPORTUNIDADES ESTÁNDARES ASISTENCIALES)">
        <RowFromComentarios
          items={tBy(
            "6.12.\tCONCLUSIONES (INVOLUCRA FORTALEZAS Y OPORTUNIDADES DE MEJORAMIENTO DE LOS ESTANDARESASISTENCIALES)",
          )}
        />
        <ResumenOmEvaluador id={idInstitucion} />
      </Section>

      {/* 7. ESTÁNDARES ADMINISTRATIVOS */}
      <Section title="7.1. DIRECCIONAMIENTO">
        <EquipoDireccionamiento idSolicitud={idSolicitud} />
        <RowFromComentarios items={tBy("7.1.\tDIRECCIONAMIENTO")} />
      </Section>

      <Section title="7.2. GERENCIA">
        <EquipoGerencia idSolicitud={idSolicitud} />
        <RowFromComentarios items={tBy("7.2. GERENCIA")} />
      </Section>

      <Section title="7.3. GERENCIA DEL TALENTO HUMANO">
        <EquipoTalentoHumano idSolicitud={idSolicitud} />
        <RowFromComentarios items={tBy("7.3.\tGERENCIA DEL TALENTO HUMANO")} />
        <RowFromComentarios
          items={tBy(
            "7.3.1 Describa y analice la disponibilidad del recurso humano de acuerdo con los modelos de contratacion.",
          )}
        />
        <Section title="7.3.2 Ratio profesional - paciente">
          <RowFromComentarios
            items={tBy(
              "7.3.2 Describa la ratio profesional - paciente y analice la suficiencia de personal por cama principalmente de cargos como Enfermeras, Enfermeras Especializadas, Auxiliares de enfermería, Médicos Generales, Médicos Especialistas, Químicos Farmacéuticos, Trabajadores Sociales, Nutricionistas, Ingenieros Biomédicos",
            )}
          />
          <TrabajdoresInforme id={idInstitucion} />
        </Section>
      </Section>

      <Section title="7.4. GERENCIA DEL AMBIENTE FÍSICO">
        <EquipoAmbienteFisico idSolicitud={idSolicitud} />
        <RowFromComentarios items={tBy("7.4.GERENCIA DEL AMBIENTE FISICO.")} />
      </Section>

      <Section title="7.5. GESTIÓN DE TECNOLOGÍA">
        <EquipoTecnologia idSolicitud={idSolicitud} />
        <RowFromComentarios items={tBy("7.5.\tGESTION DE TECNOLOGIA.")} />
      </Section>

      <Section title="7.6. GERENCIA DE LA INFORMACIÓN">
        <EquipoGerenciaInformacion idSolicitud={idSolicitud} />
        <RowFromComentarios items={tBy("7.6.\tGERENCIA DE LA INFORMACION.")} />
      </Section>

      <Section title="7.7. PRESTACIÓN DE SERVICIOS DE APOYO POR TERCEROS">
        <RowFromComentarios
          items={tBy("7.7.  PRESTACION DE SERVICIOS DE APOYO POR TERCEROS.")}
        />
      </Section>

      <Section title="7.8. COMITÉS ADMINISTRATIVOS">
        <RowFromComentarios items={tBy("7.8.\tCOMITES ADMINISTRATIVOS ")} />
      </Section>

      <Section title="7.9. RESULTADOS Y ANÁLISIS DE INDICADORES ADMINISTRATIVOS Y FINANCIEROS">
        <RowFromComentarios
          items={tBy(
            "7.9.\tRESULTADOS Y ANALISIS DE INDICADORES ADMINISTRATIVOS Y FINANCIEROS",
          )}
        />
      </Section>

      <Section title="7.10. RESULTADOS OPORTUNIDADES DE MEJORAMIENTO ADMINISTRATIVAS (JUNTA) ANTERIOR">
        <RowFromComentarios
          items={tBy(
            "7.10.\tRESULTADOS DE LA IMPLEMENTACION DE LAS OPORTUNIDADES DE MEJORAMIENTO ADMINISTRATIVAS (JUNTA) DE LA EVALUACION ANTERIOR",
          )}
        />
      </Section>

      {/* 8. INVESTIGACIÓN / DOCENCIA / PUBLICACIONES */}
      <Section title="8.1 Gobierno Clinico de Alto Nivel ">
        <RowFromComentarios
          items={tBy("8.1 Gobierno Clinico de Alto Nivel ")}
        />
      </Section>
      <Section title="8.2 Centros de Excelencia">
        <RowFromComentarios items={tBy("8.2 Centros de Excelencia")} />
      </Section>
      <Section title="8.3 Desarrollo y evaluacion de la relacion Docencia-Servicio, investigacion, produccion cientifica, publicaciones en revistas indexadas">
        <RowFromComentarios
          items={tBy(
            "8.3 Desarrollo y evaluacion de la relacion Docencia-Servicio, investigacion, produccion cientifica, publicaciones en revistas indexadas",
          )}
        />
      </Section>
      <Section title="8.4 Otros">
        <RowFromComentarios items={tBy("8.4 Otros")} />
      </Section>

      {/* 9. MEJORAMIENTO SISTÉMICO DE LA CALIDAD */}
      <div className="text-center">
        <div className="card-header py-3">
          <h5 className="m-0 font-weight-bold text-primary">
            9. ESTADO Y AVANCES DE LOS ESTÁNDARES DE MEJORAMIENTO SISTÉMICO DE
            LA CALIDAD
          </h5>
        </div>
      </div>
      <Section title="9.1. CONCLUSIONES (FORTALEZAS Y OPORTUNIDADES DE MEJORAMIENTO – SISTÉMICO INSTITUCIONAL)">
        <RowFromComentarios
          items={tBy(
            "9.1.	CONCLUSIONES (INVOLUCRA FORTALEZAS Y OPORTUNIDADES DE MEJORAMIENTO DE LOS ESTANDARESDE MEJORAMIENTO SISTeMICO INSTITUCIONAL)",
          )}
        />
        <ResumenOmEvaluador id={idInstitucion} />
      </Section>

      {/* 10. REUNIÓN DE CIERRE */}
      <div className="text-center">
        <div className="card-header py-3">
          <h5 className="m-0 font-weight-bold text-primary">
            10. REUNIÓN DE CIERRE
          </h5>
        </div>
      </div>
      <Section title="10.1 FORTALEZAS">
        <RowFromComentarios items={tBy("10.1 FORTALEZAS")} />
      </Section>
      <Section title="10.2 OPORTUNIDADES DE MEJORAMIENTO">
        <RowFromComentarios items={tBy("10.2 OPORTUNIDADES DE MEJORAMIENTO")} />
      </Section>

      {/* 11. CALIFICACIONES */}
      <div className="text-justify">
        <h6 className="m-0 font-weight-bold text-primary">
          11. CALIFICACIONES
        </h6>
        <div className="table-responsive">
          <center>
            <table border={0}>
              <thead>
                <tr>
                  <div className="text-center">
                    <br />
                  </div>
                </tr>
              </thead>
              <tbody>
                <Tabla11Obtener idSolicitud={idSolicitud} />
              </tbody>
            </table>
          </center>
        </div>
      </div>

      {/* Extras que ya usaba el original */}
      <InfoTrabajadores id={idInstitucion} />

      {/* Ejemplo de uso de resultados (si fuese necesario): */}
      {/* console.log(resultadosAbierta, resultadosSeleccion, resultadosCalificacion, equipoEvaluador); */}
    </div>
  );
};

export default InformeEvaluador;
